<template>
  <Feature :title="'系統公告'" :iconClass="'fa-user-circle-o'">
    <div class="d-flex" id="wrapper">
      <div class="bg-light border" id="sidebar-wrapper" ref="left">
        <div class="row">
          <div class="col-sm text-left">
            <RadioGroup v-model="effectiveDate">
              <Radio label="All"></Radio>
              <Radio label="有效公告"></Radio>
            </RadioGroup>
          </div>
          <div class="col-sm text-right">
            <Button
              class=""
              :size="'small'"
              icon="md-add"
              type="primary"
              shape="circle"
              @click="newAccouncement"
            ></Button>
          </div>
        </div>
        <div id="line"></div>
        <div class="list-group list-group-flush overflow-auto vh-75">
          <a
            v-for="subject in subjectList"
            :key="subject.id"
            href="javascript:void(0)"
            class="list-group-item list-group-item-action py-3 lh-tight"
            @click="selectSubject(subject)"
            :class="{ 'list-group-item-dark': subject.id === selectedSubject.id }"
          >
            <div class="d-flex w-100 align-items-center justify-content-between">
              <Icon :type="iconDisplay(subject.type)" size="28" color="DodgerBlue" />
              <strong>{{ subject.startEffectDate }}~{{ subject.endEffectDate }}</strong>
              <Button type="warning" size="small" style="width: 70px" v-if="!subject.announcable">Temp</Button>
              <Button type="success" size="small" style="width: 70px" v-if="subject.announcable">Submit</Button>
              <Icon type="md-attach" size="28" :style="[subject.attachment ? {} : { visibility: 'hidden' }]" />
            </div>
            <div class="col-12 mb-1">
              <p class="side-bar-area">{{ subject.title }}</p>
            </div>
          </a>
        </div>
      </div>
      <div id="line" @mousedown="drag($event)"></div>
      <div id="page-content-wrapper" ref="right" v-if="selectedSubject.id || editorStatus === 'new'">
        <div class="container-fluid">
          <div class="row" v-if="editorStatus === 'new'">
            <div class="col-sm text-left">
              <Alert type="warning">新建</Alert>
            </div>
          </div>
          <div class="row">
            <div class="col-sm text-left">發布者: {{ selectedSubject.createrCode }}</div>
          </div>
          <div class="row">
            <div class="col-sm text-left">
              有效日期:
              <DatePicker
                type="date"
                show-week-numbers
                placeholder="Select date"
                style="width: 200px"
                :value="selectedSubject.startEffectDate"
                @on-change="changeDate('startEffectDate', $event)"
              ></DatePicker>
              ~
              <DatePicker
                type="date"
                show-week-numbers
                placeholder="Select date"
                style="width: 200px"
                :value="selectedSubject.endEffectDate"
                @on-change="changeDate('endEffectDate', $event)"
              ></DatePicker>
            </div>
          </div>
          <div class="row">
            <div class="col-sm text-left">
              類型:
              <Select v-model="selectedSubject.type" style="width: 200px" :disabled="isBG_ENGorVQA">
                <Option v-for="item in typeList" :value="item.value" :key="item.value" :label="item.value">
                  <Icon :type="item.icon" size="35" color="DodgerBlue" />
                  <span>{{ item.value }}</span>
                </Option>
              </Select>
            </div>
          </div>
          <div class="row" v-if="!isBG_ENGorVQA">
            <div class="col-4">
              公開:
              <i-switch
                v-model="selectedSubject.publicRole"
                size="large"
                :true-value="true"
                :false-value="false"
                slot="a"
              >
                <span slot="open">{{ $t("YES") }}</span>
                <span slot="close">{{ $t("NO") }}</span>
              </i-switch>
            </div>
          </div>
          <div class="row" v-if="!selectedSubject.publicRole">
            <div class="col-4 text-left">
              公告對象:
              <Select v-model="selectedSubject.roles" multiple style="width: 500px" :disabled="isBG_ENGorVQA">
                <Option v-for="item in targetsList" :value="item.code" :key="item.code">{{ item.name }}</Option>
              </Select>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              跳通知: 
              <i-switch
                v-model="selectedSubject.notifiable"
                size="large"
                :true-value="true"
                :false-value="false"
                slot="a"
                :disabled="isBG_ENGorVQA"
              >
                <span slot="open">{{ $t("YES") }}</span>
                <span slot="close">{{ $t("NO") }}</span>
              </i-switch>
          </div>
          </div>
          <div class="row">
            <div class="col-12">
              標題:
              <Input
                v-model="selectedSubject.title"
                placeholder="Enter something..."
                show-word-limit
                maxlength="50"
                type="text"
              ></Input>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              主題:
              <Input
                v-model="selectedSubject.subject"
                placeholder="Enter something..."
                show-word-limit
                maxlength="180"
                type="textarea"
                size="large"
              ></Input>
            </div>
          </div>
          <br/>
          <froala :config="FloraEditorConfig" v-model="selectedSubject.content"></froala>
          <div class="row">
            <div class="col-2">
              <Upload
                ref="upload"
                :on-progress="handleProgress"
                :on-success="handleSuccess"
                :on-error="handleError"
                :action="getUploadurl()"
                :headers="getHeaders()"
                :max-size="20 * 1024"
                :on-exceeded-size="handleMaxSize"
              >
                <Button type="info" icon="ios-cloud-upload-outline">Upload</Button>
              </Upload>
            </div>
            <div class="col text-right">
              <Button type="warning" class="mr-2" @click="saveAccouncement(false)" :disabled="!formValid"
                ><Icon type="ios-add" />Temp</Button
              >
              <Button type="success" class="mr-2" @click="saveAccouncement(true)" :disabled="!formValid"
                ><Icon type="md-folder" />Submit</Button
              >
              <Button type="error" class="mr-2" v-if="editorStatus === 'edit'" @click="remove()"
                ><Icon type="md-close" />Delete</Button
              >
            </div>
          </div>
          <div class="row">
            <a
              class="ml-3 mr-4"
              v-if="selectedSubject.attachment"
              href="javascript:void(0)"
              @click="downloadFile(selectedSubject.attachment.id)"
            >
              {{ selectedSubject.attachment.fileName }}
            </a>
            <span v-if="fileAlert" class="text-danger">Please Submit before attachement change</span>
          </div>
        </div>
      </div>
      <!-- /#page-content-wrapper -->
    </div>
  </Feature>
</template>
<script>
import { typeList } from "../../util/enums/bulletin-board"
import { download } from "../../util/api/file/attachment"
import { get, upsert, remove } from "../../util/api/auth/bulletin-board"
import { searchAttribute } from "../../util/api/auth/role"
import { FloraEditorConfig, Message } from "../../util/common"
import { mapGetters, mapActions } from "vuex"
import { AlertDelete } from "@/util/alert"
import moment from "moment"
export default {
  name: "SystemAnnouncement",
  data() {
    return {
      effectiveDate: "All",
      selectedSubject: {
        startEffectDate: moment().format("YYYY-MM-DD"),
        endEffectDate: moment().format("YYYY-MM-DD"),
      },
      targetsList: [],
      subjectList: [],
      FloraEditorConfig: FloraEditorConfig(""),
      editorStatus: "",
      fileAlert: false,
    }
  },
  computed: {
    formValid() {
      const vueInstance = this
      return (
        vueInstance.selectedSubject.startEffectDate &&
        vueInstance.selectedSubject.endEffectDate &&
        vueInstance.selectedSubject.subject &&
        vueInstance.selectedSubject.content &&
        vueInstance.selectedSubject.type
      )
    },
    groupCode() {
      const vueInstance = this
      return vueInstance.getGroupCode()
    },
    isBG_ENGorVQA() {
      const vueInstance = this;
      let currentRole = vueInstance.getUserProfile().selectedGroup.mainRoles;
      if (currentRole && currentRole.filter(role => (role.code == "BG_ENG" || role.code == "VQA")).length) {
        return true;
      }
      return false;
    },
    typeList(){
      const vueInstance = this;
      return vueInstance.isBG_ENGorVQA ? typeList : typeList.filter(type => (type.value !== "REFERENCE_FILE"));
    } 
  },
  created() {
    const vueInstance = this
    searchAttribute(vueInstance, {
      attributeDtos: [
        {
          key: "GROUP_PERSON",

          value: "Group",
        },

        {
          key: "MAIN_ROLE",

          value: "Y",
        },
      ],

      paged: false,
    }).then(res => {
      vueInstance.targetsList = res.data?._embedded?.roleResourceList
    })
    vueInstance.search()
  },
  methods: {
    ...mapGetters(["getSmallDevice", "getLogin", "getGroupCode", "getUserProfile", "getUploadurl", "getHeaders"]),
    ...mapActions(["setLanguage", "setLogin", "toggleLoading"]),
    drag(ev) {
      const vueInstance = this
      var leftChild = vueInstance.$refs.left
      var rightChild = vueInstance.$refs.right
      var iEvent = ev || event
      var dx = iEvent.clientX
      var leftWidth = leftChild.offsetWidth
      var rightWidth = rightChild.offsetWidth
      document.onmousemove = function(ev) {
        var iEvent = ev || event
        var diff = iEvent.clientX - dx
        if (200 < leftWidth + diff && 200 < rightWidth - diff) {
          leftChild.style.width = leftWidth + diff + "px"
          this.leftTableWidth = leftWidth + diff
          rightChild.style.width = rightWidth - diff + "px"
          this.rightTableWidth = rightWidth - diff
        }
      }
      document.onmouseup = function() {
        document.onmousedown = null
        document.onmousemove = null
      }
    },
    selectSubject(subject) {
      const vueInstance = this
      vueInstance.selectedSubject = Object.assign({}, subject)
      vueInstance.editorStatus = "edit"
      vueInstance.fileAlert = false
      console.log(subject)
      if (vueInstance.isBG_ENGorVQA) {
        vueInstance.selectedSubject.notifiable = true;
        vueInstance.selectedSubject.roles = ['SUPPLIER'];
        vueInstance.selectedSubject.type = 'REFERENCE_FILE';
        vueInstance.selectedSubject.publicRole = false;
      }
    },
    iconDisplay(type) {
      const vueInstance = this
      return vueInstance.typeList.find(item => item.value === type)?.icon
    },
    newAccouncement() {
      const vueInstance = this
      vueInstance.selectedSubject = {
        createrCode: vueInstance.getGroupCode().code,
        startEffectDate: moment.utc().format("YYYY-MM-DD"),
        endEffectDate: moment().format("YYYY-MM-DD"),
        type: vueInstance.isBG_ENGorVQA ? "REFERENCE_FILE" : "",
        title: "",
        subject: "",
        content: "",
        notifiable: vueInstance.isBG_ENGorVQA ? true : false,
        announcable: true,
        attachment: null,
      }
      if (vueInstance.isBG_ENGorVQA) {
        vueInstance.selectedSubject.roles = ['SUPPLIER'];
        vueInstance.selectedSubject.publicRole = false;
      }
      vueInstance.editorStatus = "new"
    },
    saveAccouncement(status) {
      const vueInstance = this
      vueInstance.toggleLoading(true)
      vueInstance.selectedSubject.createdBy = vueInstance.getUserProfile().user.code
      vueInstance.selectedSubject.createrCode = vueInstance.getGroupCode().code
      vueInstance.selectedSubject.announcable = status
      upsert(vueInstance, vueInstance.selectedSubject).then(res => {
        if (res.data.type === "success") {
          vueInstance.$Message.success(res.data.content[0].status)
          vueInstance.search()
        }
      })
    },
    handleProgress() {
      const vueInstance = this
      vueInstance.toggleLoading(true)
    },
    handleSuccess(res) {
      let vueInstance = this
      if (!vueInstance.selectedSubject.attachment) {
        vueInstance.selectedSubject.attachment = {}
      }
      vueInstance.fileAlert = true
      vueInstance.selectedSubject.attachment = res
      vueInstance.toggleLoading(false)
      vueInstance.$refs.upload.clearFiles()

      Message(vueInstance, "success", this.$t("UPLOAD") + " " + this.$t("COMMON_MESSAGE_SUCCESS"))
    },
    handleError() {
      let vueInstance = this
      vueInstance.toggleLoading(false)
      vueInstance.$refs.upload.clearFiles()
      Message(vueInstance, "error", this.$t("UPLOAD") + " " + this.$t("COMMON_MESSAGE_ERROR"))
    },
    handleMaxSize() {
      let vueInstance = this
      vueInstance.toggleLoading(false)
      vueInstance.$refs.upload.clearFiles()
      Message(vueInstance, "error", "File size is too large, limit file size is 20MB")
    },
    search() {
      const vueInstance = this
      vueInstance.subjectList = []
      vueInstance.selectedSubject = {}
      vueInstance.editorStatus = ""
      vueInstance.toggleLoading(true)
      get(vueInstance, !(vueInstance.effectiveDate === "All"), false, 0, 2000)
        .then(res => {
          if (res.status === 200) {
            res.data.forEach(o => {
              o.createdTime = moment(o.created).valueOf()
            })
            res.data.sort((a, b) => b.createdTime - a.createdTime)
            vueInstance.subjectList = res.data
          }
        })
        .catch(error => {
          if (error.response.status == 444) {
            let text = vueInstance.$buildErrorMessage(error)
            this.$Swal.fire({
              icon: "error",
              title: Translate("COMMON_MESSAGE_ERROR"),
              text,
            })
          }
        })
        .finally(() => {
          vueInstance.toggleLoading(false)
        })
    },
    remove() {
      const vueInstance = this
      AlertDelete(vueInstance, "").then(res => {
        vueInstance.toggleLoading(true)
        remove(vueInstance, vueInstance.selectedSubject.uuid).then(res => {
          vueInstance.toggleLoading(false)
          this.$Message.success(res.data.content[0].status)
          vueInstance.search()
        })
      })
    },
    changeDate(column, date) {
      const vueInstance = this
      vueInstance.selectedSubject[column] = date
    },
    downloadFile(uuid) {
      let vueInstance = this
      vueInstance.toggleLoading(true)
      download(vueInstance, uuid)
    },
  },
  watch: {
    effectiveDate: function() {
      const vueInstance = this
      vueInstance.search()
    },
  },
}
</script>
<style>
body {
  overflow-x: hidden;
}

#sidebar-wrapper .sidebar-heading {
  padding: 0.875rem 1.25rem;
  font-size: 1.2rem;
}

#page-content-wrapper {
  min-width: 100vw;
}

#wrapper.toggled #sidebar-wrapper {
  margin-left: 0;
}
.side-bar-area {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  white-space: normal;
}

@media (min-width: 768px) {
  #sidebar-wrapper {
    margin-left: 0;
    min-width: 22rem;
    width: 22rem;
  }

  #page-content-wrapper {
    min-width: 0;
    width: 100%;
  }

  #wrapper.toggled #sidebar-wrapper {
    margin-left: -15rem;
  }
}
.vh-75 {
  height: 75vh !important;
}
#line {
  flex-basis: 3px;
  position: relative;
  z-index: 2;
  cursor: col-resize;
  border-left: 1px solid rgba(255, 255, 255, 0.05);
  border-right: 1px solid rgba(0, 0, 0, 0.4);
  background: #333642;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
